(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trHeader', trHeader);

  function trHeader() {
    const directive = {
      restrict: 'E',
      scope: {
        isThemeEditorOpen: '<'
      },
      controller: 'HeaderController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/components/header/header.view.html'
    };
    return directive;
  }
})();
